import gql from 'graphql-tag';

import jobCopyIntegrationItemFragment from '../fragments/jobCopyIntegrationItemFragment';

export const mutationCreateJobCopyIntegrationItem = gql`
  mutation createJobCopyIntegrationItem(
    $integrationID: DokkioID!
    $remoteID: ID!
    $newIntegrationID: DokkioID!
    $newParentRemoteID: ID!
    $newSlackChannelRemoteID: ID
    $newName: String
  ) {
      createJobCopyIntegrationItem(
        integrationID: $integrationID
        remoteID: $remoteID
        newIntegrationID: $newIntegrationID
        newParentRemoteID: $newParentRemoteID
        newSlackChannelRemoteID: $newSlackChannelRemoteID
        newName: $newName
      ) {
        ...jobCopyIntegrationItemFragment
      }
  }
  ${jobCopyIntegrationItemFragment}
`;

export default mutationCreateJobCopyIntegrationItem;
